import "./dom_extend";

export const Ajax = {};

//
// V případě, že se AJAXový požadavek vrátil, emitujeme události
// "ajaxsuccess" (resp. "ajaxerror") a "ajaxcompleted".
//
// Navíc provedeme alespoň základní pokus o převod návratové hodnoty do JSON (je-li
// odpověď v tomto formátu).
//
function onAjaxResponse(kind, status, event, callback, form, xhr) {
	var responseJSON = null;
	try {
		responseJSON = JSON.parse(event.target.response);
	} catch (exception) {
	}

	var form = form ? form : null;
	var emitter = form ? form : document;

	emitter.trigger("ajax" + kind, { status: status, event: event, form: form, response: event.target.response, responseJSON: responseJSON, xhr: xhr }, true);
	emitter.trigger("ajaxcompleted", { status: status, event: event, form: form, response: event.target.response, responseJSON: responseJSON, xhr: xhr }, true);

	if (kind == "error") {
		console.error("AJAX: Při vyřizování AJAX požadavku došlo k chybě.");
	}

	if (callback) {
		callback({ event: event, response: event.target.response, responseJSON: responseJSON, xhr: xhr });
	}
}

function onAjaxBefore(form) {
	// Před samotným vysláním AJAXového požadavku emitneme událost "ajaxbefore".
	// To se může hodit např. pro zobrazení točícího kolečka nebo něco podobného.

	var form = form ? form : null;
	var emitter = form ? form : document;

	emitter.trigger("ajaxbefore", { form: form }, true);
}

function getCsrfToken() {
	return document.head.querySelector("meta[name='csrf-token']").getAttribute("content");
}


// *************************************************************************
// Obecný GET požadavek.
// *************************************************************************

Ajax.get = function(url, headers) {
	return new Promise(function(resolve, reject) {
		onAjaxBefore();

		var xhr = new XMLHttpRequest();

		xhr.addEventListener("load", function(event) {
			onAjaxResponse("success", xhr.status, event, resolve, null, xhr);
		});
		xhr.addEventListener("error", function(event) {
			onAjaxResponse("error", xhr.status, event, reject, null, xhr);
		});

		xhr.open("GET", url);
		xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

		if (headers) {
			for (const key in headers) {
				xhr.setRequestHeader(key, headers[key]);
			}
		}

		xhr.send();
	});
}


// *************************************************************************
// Obecný POST požadavek.
// *************************************************************************

Ajax.post = function(url, data) {
	return new Promise(function(resolve, reject) {
		onAjaxBefore();

		var xhr = new XMLHttpRequest();

		xhr.addEventListener("load", function(event) {
			onAjaxResponse("success", xhr.status, event, resolve, null, xhr);
		});
		xhr.addEventListener("error", function(event) {
			onAjaxResponse("error", xhr.status, event, reject, null, xhr);
		});

		xhr.open("POST", url);
		xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
		xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhr.setRequestHeader("X-CSRF-Token", getCsrfToken());

		var encoded = "";
		for (var key in data) {
			if (encoded) {
				encoded += "&";
			}
			encoded += encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
		}

		xhr.send(encoded);
	});
}


// *************************************************************************
// Odeslání formuláře.
// *************************************************************************

Ajax.submit = function(form, submitter) {
	return new Promise(function(resolve, reject) {
		var method = form.getAttribute("method");
		var action = form.getAttribute("action");

		form.classList.add("sending-request");
		onAjaxBefore(form);

		var xhr = new XMLHttpRequest();
		var formData = new FormData(form);

		if (submitter && submitter.name) {
			formData.append(submitter.name, submitter.value);
		}

		xhr.addEventListener("load", function(event) {
			form.classList.remove("sending-request");
			onAjaxResponse("success", xhr.status, event, resolve, form, xhr);
		});
		xhr.addEventListener("error", function(event) {
			form.classList.remove("sending-request");
			onAjaxResponse("error", xhr.status, event, reject, form, xhr);
		});

		if (method.toUpperCase() == "GET") {
			// Požadavek GET a POST se liší. U GET požadavku data předáváme v URL.

			var formDataEntries = formData.entries();
			var formDataEntry = formDataEntries.next();
			while (!formDataEntry.done) {
				var key = formDataEntry.value[0];
				var value = formDataEntry.value[1];

				if (0 <= action.indexOf("?")) {
					action += "&";
				}
				else {
					action += "?";
				}
				action += encodeURIComponent(key) + "=" + encodeURIComponent(value);

				formDataEntry = formDataEntries.next();
			}

			xhr.open(method, action);
			xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
			xhr.setRequestHeader("X-CSRF-Token", getCsrfToken());
			xhr.send();
		}
		else {
			xhr.open(method, action);
			xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
			xhr.setRequestHeader("X-CSRF-Token", getCsrfToken());
			xhr.send(formData);
		}

	});
}


//
// Odeslání formuláře přes AJAX stačí odchytnutím události "submit",
// není nutné předem "skenovat" DOM strom, vyhledat všechny formuláře
// a k nim registrovat handlery události "submit".
//
document.addEventListener("submit", function(event) {
	let form = event.target;
	if (!form.matches("form[data-remote='true']")) {
		return;
	}

	let submitter = event.submitter;

	// Temporary "polyfill".
	// For Safari bellow 15, there must be onclick attribute on submit buttons:
	// <button onlick="this.form.eventSubmitter = this">
	if (!submitter && form.eventSubmitter) {
		submitter = form.eventSubmitter;
		form.eventSubmitter = null;
	}

	if (!submitter || !submitter.matches("[data-remote='false']")) {
		event.preventDefault();
		Ajax.submit(form, submitter);
	}
});
